import React, { useImperativeHandle, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';

import Popup from '@ecp/common/src/components/modal/bo/Popup';

import GridContainer from '@bo-components/common/grid/GridContainer';
import { handleGridFunctionPropTypes, IBSheetEventPropTypes } from '@bo-components/common/grid/gridPropTypes';
import { Custom_Preset } from '@bo-ibSheet/common';

const GridPopup = React.forwardRef(
  ({ uploadPopupOpen, hideUploadPopup, headerText, reloadData, options, onSave, ...props }, ref) => {
    const { title } = props;
    const popupRef = useRef(null);

    useImperativeHandle(ref, () => popupRef.current);

    const handleUploadPopupConfirm = async () => {
      await popupRef.current.handleSave();
    };

    const handleSave = async (changedData) => {
      await onSave?.(changedData);

      await reloadData?.();

      hideUploadPopup();
    };

    const popupOptions = useMemo(() => {
      const RightCols = options.RightCols || [];
      return {
        ...options,
        LeftCols: [Custom_Preset.CheckBox, Custom_Preset.SEQ],
        RightCols: [...RightCols, Custom_Preset.ErrorDescription],
      };
    }, [options]);

    return (
      <Popup
        type={'Large'}
        open={uploadPopupOpen}
        header={headerText || title}
        onClose={hideUploadPopup}
        onCancelClick={hideUploadPopup}
        onConfirmClick={handleUploadPopupConfirm}
        useCancelButton={true}
        useConfirmButton={true}
        confirmButtonText={'저장'}
      >
        <GridContainer
          {...props}
          unPaged
          hideFooter
          data={[]}
          total={undefined}
          excel={'excelWork'}
          readOnly={false}
          showUploadPopup={false}
          showDelete={true}
          showCopy={true}
          showAddRow={true}
          showRegister={false}
          replaceDataByExcel={true}
          options={popupOptions}
          onSave={handleSave}
          ref={popupRef}
        />
      </Popup>
    );
  }
);

GridPopup.propTypes = {
  /* popup */
  headerText: PropTypes.string,
  uploadPopupOpen: PropTypes.bool,
  hideUploadPopup: PropTypes.func,
  handleUploadPopupConfirm: PropTypes.func,
  reloadData: PropTypes.func,
  /* grid */
  options: PropTypes.object,
  initRow: PropTypes.object,
  height: PropTypes.string,
  title: PropTypes.string,
  showFocusedBackground: PropTypes.bool,
  /* RightHeaderButtons */
  addRowLabel: PropTypes.string,
  /* Paging */
  total: PropTypes.number,
  /* Handle Functions */
  ...handleGridFunctionPropTypes,
  /* IBSheet Event */
  ...IBSheetEventPropTypes,
};

GridPopup.defaultProps = {
  data: [],
  options: {},
  initRow: {},
  title: 'Table',
  validators: {},
  addRowLabel: '행추가',
  unPaged: true,
  unLoaded: true,
  height: '495px',
};

GridPopup.displayName = 'GridPopup';

export default GridPopup;
